/**
 * @module helper.array
 */

export function randomSort<T>(source: T[]): T[] {
	if (!Array.isArray(source)) {
		throw new Error('source should be array.');
	}

	return source.sort(() => 0.5 - Math.random());
}
